<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs11 sm12 m12>

            <v-navigation-drawer width="450" permanent="" fixed="" app v-model="drawer">
              <v-layout row wrap align-center>
                <v-list dense>
                  <v-layout row wrap align-center ma-3>
                    <v-flex xs6 sm6 md6>
                      <v-layout align-center justify-start>
                        <!-- {{$t('Password')}} -->
                        <v-menu offset-y>
                          <v-btn slot="activator" flat="">
                            <img v-if="this.locale=='tr'" style="height:32px; width:32px;"
                              src="../../../assets/images/turkey.png">
                            <img v-if="this.locale=='en'" style="height:32px; width:32px;"
                              src="../../../assets/images/english.png">
                            <img v-if="this.locale=='de'" style="height:32px; width:32px;"
                              src="../../../assets/images/germany.png">

                          </v-btn>
                          <v-list>
                            <v-list-tile v-for="(locale, index) in locales" :key="index">
                              <v-list-tile>
                                <v-list-tile-avatar @click="changeLanguage(locale.locale)">
                                  <!-- <img v-bind:src="locale.href" width="24px"> -->
                                  <img style="height:32px; width:32px;" :src="getImgUrl(locale.href)">
                                </v-list-tile-avatar>
                                <v-list-tile-title>
                                  {{ locale.title }}
                                </v-list-tile-title>
                              </v-list-tile>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </v-layout>
                    </v-flex>



                    <v-flex class="text-xs-center" pt-30 pb-3 xs12 sm12 md12>
                      <div class="text-xs-center" style="margin-bottom:15px;">
                        <img src="../../../assets/images/ark.png" alt="Arkman">
                      </div>
                    </v-flex>

                    <v-flex class="text-xs-center" pb-3 xs12 sm12 md12>
                      <span class="grey--text title">ARKMAN</span> <span class="info--text title">DOT9</span>
                      <!-- <div class="text-xs-center" style="margin-bottom:15px;">
                        <img src="../../../assets/images/awedlogo.jpg" alt="Arkman">
                      </div> -->
                    </v-flex>

                    <v-form>
                      <v-layout v-if="loginstatus" row wrap>
                        <v-flex sm12 md12>
                          <v-alert :type="alerttype" :value="true" v-model="errorAlert" transition="scale-transition">
                            <span>{{ errorMsg }}</span>
                          </v-alert>

                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-text-field prepend-icon="person" box="" placeholder="Cari Kod" name="email"
                            v-model="LoginParams.CariKodu" label="Cari Kod" type="text"
                            :rules="[rules.required]">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-text-field prepend-icon="lock" box="" placeholder="Şifre" name="password"
                            v-model="LoginParams.Dot9Sifre" label="Şifre" id="password" v-on:keyup.13="apiLogin"
                            :type="e2 ? 'password' : 'text'" :rules="[rules.required]"
                            :append-icon="e2 ? 'visibility' : 'visibility_off'" :append-icon-cb="() => (e2 = !e2)">
                          </v-text-field>
                        </v-flex>

                        <v-flex xs6 sm6 md6>
                          <!-- <v-btn @click="sifremiunuttum()" color="grey" flat>
                            <v-icon large>contact_support</v-icon> &nbsp; &nbsp;Şifremi Unuttum
                          </v-btn> -->

                        </v-flex>


                        <v-flex xs6 sm6 md6>
                          <v-layout justify-end>
                            <v-btn v-if="!bekle" :disabled="errorAlert" color="light-blue lighten-2" @click="apiLogin"><span
                                class="white--text">Giriş</span></v-btn>
                            <v-progress-circular v-if="bekle" indeterminate color="info"></v-progress-circular>

                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-divider dark class="my-3"></v-divider>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout justify-start>
                            <v-list-tile>
                              <v-list-tile-action>
                                <v-layout row wrap justify-start>
                                  <!-- <v-flex xs12 sm12 md12>
                                    <v-btn @click="newUser()" color="grey" flat>
                                      <v-icon large>group_add</v-icon> &nbsp; &nbsp; Yeni Kullanıcı
                                    </v-btn>
                                  </v-flex> -->
                                  <v-flex xs12 sm12 md12>

                                  </v-flex>
                                </v-layout>
                              </v-list-tile-action>
                              <v-list-tile-content>
                                <v-list-tile-title @click.stop="newUser()" class="title grey--text">

                                </v-list-tile-title>
                              </v-list-tile-content>
                            </v-list-tile>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-form>

                    <v-form ref="formnewuserstatus" v-model="valid">
                      <v-layout v-if="newuserstatus" row wrap>
                        <v-flex sm12 md12>
                          <v-layout align-center justify-center="" row fill-height>
                            <div> <strong class="title primary--text">Yeni Kullanıcı Bilgileri</strong></div>
                          </v-layout>
                        </v-flex>
                        <v-flex sm12 md12>
                          <v-alert :type="alerttype" :value="true" v-model="yenierrorAlert"
                            transition="scale-transition">
                            <span>{{ yenierrorMsg }}</span>
                          </v-alert>
                        </v-flex>
                        <v-flex sm12 md12>
                          <v-text-field prepend-icon="subtitles" box="" :rules="[rules.required]" placeholder="Ünvan"
                            v-model="unvan" label="Ünvan"></v-text-field>
                        </v-flex>
                        <v-flex sm12 md12>
                          <v-text-field prepend-icon="person" box="" :rules="[rules.required]" placeholder="Ad Soyad"
                            v-model="YeniKullanici.AdSoyad" label="Ad Soyad"></v-text-field>
                        </v-flex>
                        <v-flex sm12 md12>
                          <v-text-field prepend-icon="email" box="" placeholder="E-mail" v-model="YeniKullanici.email"
                            label="Email" :rules="[rules.required]"></v-text-field>
                        </v-flex>
                        <v-flex sm12 md12>
                          <v-text-field prepend-icon="lock" box="" counter="8" placeholder="Şifre"
                            v-model="YeniKullanici.Sifre" label="Şifre" id="password1" :type="e3 ? 'password' : 'text'"
                            :rules="[rules.required]" :append-icon="e3 ? 'visibility' : 'visibility_off'"
                            :append-icon-cb="() => (e3 = !e3)"></v-text-field>
                        </v-flex>
                        <v-flex sm12 md12>
                          <v-text-field prepend-icon="lock" box="" counter="8" placeholder="Şifre Tekrar"
                            v-model="confirm" label="Şifre" id="password2" :type="e4 ? 'password' : 'text'"
                            :rules="[rules.required]" :append-icon="e4 ? 'visibility' : 'visibility_off'"
                            :append-icon-cb="() => (e4 = !e4)"></v-text-field>
                        </v-flex>
                        <v-flex sm12 md12>
                          <v-layout justify-end="">

                            <v-btn :disabled="yenikayitbekle" color="info" @click="geriDon()">Geri Dön</v-btn>
                            <v-btn :disabled="yenikayitbekle" color="info" @click="saveUser()">Kayıt Ol</v-btn>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm12 md12>
                          <v-layout justify-center="">
                            <v-progress-circular v-if="yenikayitbekle" indeterminate color="info"></v-progress-circular>
                          </v-layout>
                        </v-flex>

                      </v-layout>
                    </v-form>

                    <v-form ref="formemail" v-model="valid">
                      <v-layout v-if="emailstatus" row wrap>

                        <v-flex xs12 sm12 md12>
                          <v-text-field prepend-icon="email" box="" placeholder="E-mail" v-model="Emailyeni"
                            label="Email" :rules="[rules.required]"></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout justify-end="">
                            <v-btn :disabled="sifresifirlabekle" color="info" @click="geriDon()">Geri Dön</v-btn>
                            <v-btn :disabled="sifresifirlabekle" color="info" @click="sifresifirla()">Şifremi Sıfırla
                            </v-btn>
                          </v-layout>
                        </v-flex>
                        <v-flex xs12 sm12 md12>
                          <v-layout justify-center="">

                            <v-progress-circular v-if="sifresifirlabekle" indeterminate color="info">
                            </v-progress-circular>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-form>


                  </v-layout>
                </v-list>
              </v-layout>
            </v-navigation-drawer>

            <v-container>
              <v-layout>



              </v-layout>
            </v-container>



          </v-flex>
        </v-layout>
      </v-container>
      <template>
        <v-card>
          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
          </v-snackbar>
        </v-card>
      </template>

    </v-content>
  </v-app>




</template>

<script>
  import auth from '../../../api/auth'
  import _ from 'underscore'
  import router from '../../../router'
  import axios from 'axios'

  import {
    Trans
  } from '@/plugins/Translation'

  export default {
    data: () => ({
      id: null,
      LoginParams: {
        MusteriKodu: null,
        CariKodu: null,
        Dot9Sifre: null,
      },
      locale: 'tr',
      locales: [{
          locale: 'tr',
          title: 'Türkçe',
          href: 'turkey'
        },
        {
          locale: 'en',
          title: 'English',
          href: 'english'
        },
        {
          locale: 'de',
          title: 'Deutsch',
          href: 'germany'
        },
      ],
      Emailyeni: null,
      drawer: true,
      drawerRight: true,
      right: null,
      left: null,
      alerttype: 'error',
      yenikayitbekle: false,
      sifresifirlabekle: false,
      faturainfo: [],
      newuserstatus: false,
      loginstatus: true,
      emailstatus: false,
      drawer: null,
      e1: 0,
      e2: true,
      e3: true,
      e4: true,
      text1: '',
      snackbar: false,
      y: 'top',
      x: 'right',
      mode: '',
      bekle: false,
      timeout: 6000,
      rules: {
        required: (value) => !!value || 'Gerekli alan.',
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Hatalı e-mail.'
        }
      },
      YeniKullanici: {
        UserID: null,
        MusteriID: 0,
        KullaniciAdi: null,
        Email: null,
        Sifre: null,
        Tip: 0,
        AdSoyad: null,
        Deleted: false,
        Aktif: true,
        MusteriBilgi: [],

      },
      unvan: null,
      confirm: null,
      Credential: {
        email: '',
        password: ''
      },
      valid: true,
      errorMsg: '',
      errorAlert: false,
      yenierrorMsg: '',
      yenierrorAlert: false,
      AnaSirketler: [],
      Sirketler: [],
      AnaSirket: {},
      Sirket: {}
    }),
    beforeMount: beforeMount,
    methods: {
      musterivarmi() {
        this.id = this.$route.params.id

        var params = {
          MusteriAdi: null,
          MusteriGuid:this.id //  '3A3C6098-5B57-464E-AD95-FC482328DB90' 
          
        }

        var credentials = {
          CariBilgi: null,
          Id: this.id
        }


        window.localStorage.setItem('credentials', JSON.stringify(credentials));


        this.$http.post(auth.API_URL + 'api/Dot9/CustomerExist', params, {
          headers: {

          }
        }).then((response) => {

          if (response.body.Exist) {
            this.LoginParams.MusteriKodu = response.body.MusteriInfo.MusteriKod
            this.errorAlert = false
          } else {
            this.errorMsg = 'Şirket bilgisi bulunamadı, url kodunuz hatalı..'
            this.errorAlert = true
          }

        }, (response) => {

          this.errorMsg = 'Hata oluştu tekrar deneyiniz..'
          this.errorAlert = true
        })
      },
      sifremiunuttum() {
        this.newuserstatus = false;
        this.loginstatus = false;
        this.emailstatus = true;
      },
      changeLanguage(e) {
        const lang = e
        const to = this.$router.resolve({
          params: {
            lang
          }
        })
        return Trans.changeLanguage(lang).then(() => {
          this.$router.push(to.location)
          this.locale = e
        })
      },
      getImgUrl(pet) {
        var images = require.context('../../../assets/images', false, /\.png$/)
        return images('./' + pet + ".png")
      },
      apiLogin,
      sysLogin,
      newUser,
      geriDon,
      saveUser,
      epostagonder,
      sifresifirla
    }
  }

  function epostagonder(tip, kime, token) {


    if (tip != 'sifre') {

      var okMail = auth.URL_MAIL + 'isl=confirmmail&email=' + kime + '&&token=' + token +
        ' url adresinden mail adresinizi onaylayabilirsiniz!.'

    } else {
      var okMail = auth.URL_MAIL + 'isl=confirmsifre&email=' + kime + '&&token=' + token +
        ' url adresinden şifrenizi yenilebilirsiniz!'
    }


    let formData = new FormData();

    formData.append('Konu', 'E-Posta Onay Maili')
    formData.append('to', kime)


    formData.append('formattedMessage', okMail)

    axios.defaults.baseURL = auth.API_URL;
    // axios.responseType = 'arraybuffer';
    axios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
    axios.post(auth.API_URL + 'api/Helpers/SendEmail',
        formData, {
          headers: {

          }
        }
      ).then((response) => {

        if (response.data == true) {
          this.text1 =
            "Sistemde kayıtlı mail adresinize onay maili gönderilmiştir. Mailinizde bulunan link ile işleminize devam edebilirsiniz."
          this.snackbar = true
        } else {
          this.text1 = "Kullanıcı kayıtınız oluşturuldu, onay maili adresinize gönderilemedi."
          this.snackbar = true
        }
      })
      .catch(function () {});

  }

  function sifresifirla() {

    if (this.$refs.formemail.validate()) {

      this.sifresifirlabekle = true

      var params = {
        Email: this.Emailyeni,
        Sifre: null,
        Token: null
      }

      this.$http.post(auth.API_URL + 'api/RegisterAuth/WebPasswordReset', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        if (response.body.Status == true) {

          this.epostagonder('sifre', this.Emailyeni, response.body.UserToken)
          this.newuserstatus = false;
          this.emailstatus = false,
            this.loginstatus = true;

        } else {
          this.text1 = response.body.ResponseMessage
          this.snackbar = true;
        }
        this.sifresifirlabekle = false

      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable-WebPasswordReset'
          this.snackbar = true
          this.sifresifirlabekle = false

        } else {
          this.text1 = 'Service Unavailable-WebPasswordReset'
          this.snackbar = true
          this.sifresifirlabekle = false

        }
      })



    } else {
      console.log('form validate değil')
    }
  }

  function saveUser() {

    if (this.$refs.formnewuserstatus.validate()) {
      if (this.YeniKullanici.Sifre == this.confirm) {
        this.yenikayitbekle = true;
        this.Emailyeni = this.YeniKullanici.email
        var musteribilgi = {
          Ad: this.unvan
        }
        var musteribilgiler = [];
        musteribilgiler.push(musteribilgi)
        this.YeniKullanici.MusteriBilgi = musteribilgiler
        var params1 = this.YeniKullanici;

        this.$http.post(auth.API_URL + 'api/Register/Create', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          if (response.body.Status == true) {

            this.epostagonder('mail', this.Emailyeni, response.body.UserToken)
            this.newuserstatus = false;
            this.loginstatus = true;
            this.yenikayitbekle = false;


          } else {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true;
            this.yenikayitbekle = false;

          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Yeni Kullanıcı'
            this.snackbar = true
            this.yenikayitbekle = false;

          } else {
            this.text1 = 'Service Unavailable-Yeni Kullanıcı'
            this.snackbar = true
            this.yenikayitbekle = false;

          }
        })


      } else {
        this.alerttype = 'error';
        this.yenierrorMsg = 'Şifreler aynı değil';
        this.yenierrorAlert = true;
      }

    } else {
      console.log('form validate değil')
    }
  }

  function geriDon() {
    this.newuserstatus = false;
    this.loginstatus = true;
    this.emailstatus = false;
  }

  function newUser() {
    this.newuserstatus = true;
    this.loginstatus = false;
  }

  function apiLogin() {

    this.bekle = true;

    auth.login(this, this.LoginParams, this.id)

  }

  function sysLogin() {
    var earsiv = 0
    var efatura = 0
    var response = JSON.parse(window.localStorage.getItem('response'));
    var sirketler = JSON.parse(window.localStorage.getItem('sirketler'));
    window.localStorage.setItem('tokenreport', response.Token.token);

    var sirketparams = {
      SirketKodu: this.Sirket.id
    }
    this.$http.post(auth.API_URL + 'api/Parameters/CompanyGet', sirketparams, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {


      earsiv = response.body.OpsiyonBilgileri.EArsiv
      efatura = response.body.OpsiyonBilgileri.EFaturaKullaniyor

      var credentials = {
        AnaSirketKodu: this.AnaSirket.id,
        SirketKodu: this.Sirket.id,
        SirketAdi: this.Sirket.text,
        SirketUnvani: this.Sirket.unvan,
        Sirketler: sirketler,
        EArsiv: earsiv,
        EFatura: efatura
      }


      window.localStorage.setItem('credentials', JSON.stringify(credentials));



    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Company Get'
        this.snackbar = true
        this.load1 = true
        this.progress = false

        var credentials = {
          AnaSirketKodu: this.AnaSirket.id,
          SirketKodu: this.Sirket.id,
          SirketAdi: this.Sirket.text,
          SirketUnvani: this.Sirket.unvan,
          Sirketler: sirketler,
          EArsiv: earsiv,
          EFatura: efatura
        }

        window.localStorage.setItem('credentials', JSON.stringify(credentials));
      } else {
        this.text1 = 'Service Unavailable-Company Get'
        this.snackbar = true
        this.load1 = true
        this.progress = false
        var credentials = {
          AnaSirketKodu: this.AnaSirket.id,
          SirketKodu: this.Sirket.id,
          SirketAdi: this.Sirket.text,
          SirketUnvani: this.Sirket.unvan,
          Sirketler: sirketler,
          EArsiv: earsiv,
          EFatura: efatura
        }
        window.localStorage.setItem('credentials', JSON.stringify(credentials));
      }
    })

    window.localStorage.removeItem('response')
    window.localStorage.removeItem('sirketler')

    router.push({
      path: '/'
    })
  }



  function beforeMount() {

    this.musterivarmi();
  }
</script>